<template>
    <section>
        <sui-segment basic>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="file alternate"/>
                <sui-header-content>Registros REUNE</sui-header-content>
            </h2>
            <br>
        </sui-segment>
        <sui-segment basic>
            <sui-form v-on:submit.prevent>
                <sui-form-fields fields="four">
                    <sui-form-field>
                        <label>Folio</label>
                        <sui-input
                            v-model="searchRecord.folio"
                            placeholder="Folio"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Tipo</label>
                        <sui-dropdown
                            placeholder="Seleccione"
                            selection
                            search
                            multiple
                            v-model="searchRecord.complaintType"
                            :options="complaintTypeOptions"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Estatus del Folio</label>
                        <sui-dropdown
                            placeholder="Seleccione"
                            selection
                            search
                            multiple
                            v-model="searchRecord.statusId"
                            :options="statusOptions"
                        />
                    </sui-form-field>
                </sui-form-fields>
                <sui-form-fields fields="two">
                    <sui-form-field>
                        <label>Rango de fechas</label>
                        <v-date-picker v-model="range" is-range locale="es" @input="formatDates">
                            <template v-slot="{ inputValue, inputEvents, isDragging }">
                                <sui-form-fields fields="two">
                                    <sui-form-field>
                                        <label>Fecha inicial</label>
                                        <input
                                            class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                            :value="inputValue && inputValue.start ? inputValue.start : null"
                                            v-on="inputEvents.start"
                                          />
                                    </sui-form-field>
                                    <sui-form-field>
                                        <label>Fecha final</label>
                                        <input
                                            class="flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full"
                                            :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                            :value="inputValue && inputValue.end ? inputValue.end : null"
                                            v-on="inputEvents.end"
                                          />
                                    </sui-form-field>
                                </sui-form-fields>
                            </template>
                        </v-date-picker>
                    </sui-form-field>
                </sui-form-fields>
                <sui-button primary icon="search" @click="saveFilters(); loadRecordsByTab()">Buscar</sui-button>
                <sui-button secondary icon="cancel" @click="clearFilters()">Limpiar</sui-button>
                <sui-button positive floated="right" icon="plus" @click="addRecord()">Agregar</sui-button>
            </sui-form>
            <br><br>
            <sui-tab>
                <sui-tab-pane title="Pendientes" :label="String(totalPending || 0)">
                    <sui-form v-on:submit.prevent>
                    <sui-button
                        v-if="Utils.userHasPerm('can_send_reune_complaint')"
                        type="button"
                        class="ui right floated primary button"
                        :class="{ disabled: selectedPendingIds.length === 0 }"
                        :disabled="selectedPendingIds.length === 0"
                        @click="sendFolios"
                    ><i class="check icon"></i>Enviar Folios</sui-button>
                    </sui-form>
                    <br><br><br>
                    <tab-unpaginated-list-proxy
                        :records="notSentRecords"
                        :headers="checkBoxHeaders"
                        :processFn="processFunction"
                        :selectedItems="selectedPendingIds"
                        :onUpdateSelectedItems="setSelectedPendingIds"
                        :navigate="{ value: true, blank: false }"
                        :recordName="recordName"
                    />
                </sui-tab-pane>
                <sui-tab-pane title="Enviadas" :label="String(totalSent || 0)">
                    <tab-unpaginated-list-proxy
                        :records="sentRecords"
                        :headers="headers"
                        :processFn="processFunction"
                        :navigate="{ value: true, blank: false }"
                        :recordName="recordName"
                    />
                </sui-tab-pane>
                <sui-tab-pane title="Rechazadas" :label="String(totalRejected || 0)">
                    <sui-form v-on:submit.prevent>
                        <sui-button
                            v-if="Utils.userHasPerm('can_reset_reune_complaint')"
                            type="button"
                            class="ui right floated orange button"
                            :class="{ disabled: selectedRejectedIds.length === 0 }"
                            :disabled="selectedRejectedIds.length === 0"
                            @click="resetFolios"
                        >
                            <i class="redo icon"></i>Regresar a pendientes
                        </sui-button>
                    </sui-form>
                    <br><br><br>
                    <tab-unpaginated-list-proxy
                        :records="rejectedRecords"
                        :headers="checkBoxHeaders"
                        :processFn="processFunction"
                        :selectedItems="selectedRejectedIds"
                        :onUpdateSelectedItems="setSelectedRejectedIds"
                        :navigate="{ value: true, blank: false }"
                        :recordName="recordName"
                    />
                </sui-tab-pane>
                <sui-tab-pane title="Inhabilitadas" :label="String(totalDisabled || 0)">
                    <tab-unpaginated-list-proxy
                        :records="disabledRecords"
                        :headers="headers"
                        :processFn="processFunction"
                        :navigate="{ value: true, blank: false }"
                        :recordName="recordName"
                    />
                </sui-tab-pane>
            </sui-tab>
        </sui-segment>
    </section>
</template>

<script>
import ComplaintService from '@/services/ComplaintService'
import ReuneRecordType from '@/common/ReuneRecordType.js'
import GenericService from '@/services/GenericService.js'
import Mixins from '@/mixins/index.js'
import Utils from '@/common/Utils.js'
import GenericUnPaginatedList from '@/components/Generic/UnpaginatedList.vue'

const TabUnpaginatedListProxy = {
    name: 'TabUnpaginatedListProxy',
    components: { GenericUnPaginatedList },
    props: {
        records: { type: Array, default: () => [] },
        headers: { type: Array, default: () => [] },
        processFn: { type: Function, required: true },
        selectedItems: { type: Array, default: () => [] },
        onUpdateSelectedItems: { type: Function, default: null },
        navigate: { type: Object, default: () => ({ value: false, blank: false }) },
        recordName: { type: String, default: null }
    },
    methods: {
        processFunction (callback, item) {
            return this.processFn(callback, item)
        },
        handleUpdateSelectedItems (items) {
            if (this.onUpdateSelectedItems) this.onUpdateSelectedItems(items)
        }
    },
    render (h) {
        return h(GenericUnPaginatedList, {
            props: {
                records: this.records,
                headers: this.headers,
                selectedItems: this.selectedItems,
                navigate: this.navigate,
                recordName: this.recordName
            },
            on: {
                'update:selectedItems': this.handleUpdateSelectedItems
            }
        })
    }
}

export default {
    name: 'ReuneComplaintList',
    components: { TabUnpaginatedListProxy },
    mixins: [ Mixins ],
    data () {
        return {
            apiEndpoint: '/complaints/reune',
            recordName: 'ReuneComplaint',
            ReuneRecordType,
            activeTabIndex: 0,
            total: 0,
            totalPending: 0,
            totalSent: 0,
            totalRejected: 0,
            totalDisabled: 0,
            range: null,
            selectedPendingIds: [],
            selectedRejectedIds: [],
            records: [],
            searchRecord: {
                page: 1,
                pageSize: 35,
                order: 'DESC',
                status: []
            },
            status: [],
            operations: [],
            products: [],
            subproducts: [],
            reasons: [],
            checkBoxHeaders: [
                { type: 'checkbox', width: 1 },
                { name: 'Fecha', value: 'dateComplaint', type: 'dateShort', cellclass: 'txtc', class: 'txtc', width: 1 },
                { name: 'Folio', value: 'folio', width: 1 },
                { name: 'Cliente', type: 'object', key: 'client', value: 'entityName', width: 2 },
                { name: 'Tipo', value: 'complaintType', type: 'function', callback: 'setReuneRecordStr', width: 1 },
                { name: 'Operación', value: 'operationId', type: 'function', callback: 'setOperationStr', width: 2 },
                { name: 'Producto', value: 'productId', type: 'function', callback: 'setProductStr', width: 2 },
                { name: 'Subproducto', value: 'subproductId', type: 'function', callback: 'setSubproductStr', width: 2 },
                { name: 'Causa', value: 'reasonId', type: 'function', callback: 'setReasonStr', width: 3 },
                { name: 'Estatus', value: 'statusId', type: 'function', callback: 'setStatusStr', cellclass: 'txtc', class: 'txtc', width: 1 }
            ],
            headers: [
                { name: 'Fecha', value: 'dateComplaint', type: 'dateShort', cellclass: 'txtc', class: 'txtc', width: 1 },
                { name: 'Folio', value: 'folio', width: 1 },
                { name: 'Cliente', type: 'object', key: 'client', value: 'entityName', width: 2 },
                { name: 'Tipo', value: 'complaintType', type: 'function', callback: 'setReuneRecordStr', width: 1 },
                { name: 'Operación', value: 'operationId', type: 'function', callback: 'setOperationStr', width: 2 },
                { name: 'Producto', value: 'productId', type: 'function', callback: 'setProductStr', width: 2 },
                { name: 'Subproducto', value: 'subproductId', type: 'function', callback: 'setSubproductStr', width: 2 },
                { name: 'Causa', value: 'reasonId', type: 'function', callback: 'setReasonStr', width: 3 },
                { name: 'Estatus', value: 'statusId', type: 'function', callback: 'setStatusStr', cellclass: 'txtc', class: 'txtc', width: 1 }
            ]
        }
    },
    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },
    async mounted () {
        const loader = this.$loading.show()
        try {
            await this.loadOperations()
            await this.loadProducts()
            await this.loadSubproducts()
            await this.loadReasons()
            await this.loadStatus()
            await this.loadPendingRecords(1)
            await this.refreshTabTotals()
        } catch (error) {
            this.$swal('Error', error.message, 'error')
        }
        loader.hide()
    },
    computed: {
        selectAllPending: {
            get () {
                if (!this.notSentRecords || !this.notSentRecords.length) return false
                return this.notSentRecords.every(record => this.selectedPendingIds.includes(record.id))
            },
            set (value) {
                if (!this.notSentRecords || !this.notSentRecords.length) {
                    this.selectedPendingIds = []
                    return
                }
                this.selectedPendingIds = value ? this.notSentRecords.map(record => record.id) : []
            }
        },
        notSentRecords () {
            return this.records.filter(record => !record.reported && !record.failed && record.active)
        },
        sentRecords () {
            return this.records.filter(record => record.reported)
        },
        rejectedRecords () {
            return this.records.filter(record => record.failed && !record.reported && record.active)
        },
        disabledRecords () {
            return this.records.filter(record => !record.active && !record.reported)
        },
        statusOptions () {
            return Utils.displayOptionsFromArray(this.status, 'status_id', 'status_description')
        },
        operationOptions () {
            return Utils.displayOptionsFromArray(this.operations, 'operation_id', 'operation_description')
        },
        subproductOptions () {
            return Utils.displayOptionsFromArray(this.subproducts, 'subproduct_id', 'subproduct_description')
        },
        productOptions () {
            return Utils.displayOptionsFromArray(this.products, 'product_id', 'product_description')
        },
        reasonOptions () {
            return Utils.displayOptionsFromArray(this.reasons, 'reason_id', 'reason_description')
        },
        complaintTypeOptions () {
            return Utils.displayOptions(this.optionsLabelsTransformation)
        },
        reuneRecordOptions () {
            return Utils.displayOptions(ReuneRecordType)
        },
        optionsLabelsTransformation () {
            const newReuneRecordType = {}
            if (ReuneRecordType) {
                for (const reuneRecordTypeKey in ReuneRecordType) {
                    if (Object.hasOwnProperty.call(ReuneRecordType, reuneRecordTypeKey)) {
                        const valor = ReuneRecordType[reuneRecordTypeKey]
                        reuneRecordTypeKey === 'ACLARACION' ? newReuneRecordType['ACLARACIÓN'] = valor : newReuneRecordType[reuneRecordTypeKey] = valor
                    }
                }
            }
            return newReuneRecordType
        }
    },
    methods: {
        setSelectedPendingIds (ids) {
            this.selectedPendingIds = ids || []
        },
        getTabSearchRecord (tab, page = 1) {
            const searchRecord = { ...this.searchRecord, page }
            delete searchRecord.reported
            delete searchRecord.failed
            return searchRecord
        },
        async loadPendingRecords (page = 1) {
            const searchRecord = this.getTabSearchRecord('pending', page)
            await this.loadRecords(page, this.apiEndpoint, 'records', 'total', searchRecord)
            this.totalPending = this.total
            this.selectedPendingIds = this.selectedPendingIds.filter(id => this.records.some(record => record.id === id))
        },
        async loadSentRecords (page = 1) {
            const searchRecord = this.getTabSearchRecord('sent', page)
            await this.loadRecords(page, this.apiEndpoint, 'records', 'total', searchRecord)
            this.totalSent = this.total
        },
        async loadRecordsByTab (page = 1) {
            if (this.activeTabIndex === 0) {
                await this.loadPendingRecords(page)
                await this.refreshTabTotals()
                return
            }

            if (this.activeTabIndex === 1) {
                await this.loadSentRecords(page)
                await this.refreshTabTotals()
                return
            }

            if (this.activeTabIndex === 2) {
                await this.loadRejectedRecords(page)
                await this.refreshTabTotals()
                return
            }

            await this.loadDisabledRecords(page)
            await this.refreshTabTotals()
        },
        async loadRejectedRecords (page = 1) {
            const searchRecord = this.getTabSearchRecord('rejected', page)
            await this.loadRecords(page, this.apiEndpoint, 'records', 'total', searchRecord)
            this.totalRejected = this.total
        },
        async loadDisabledRecords (page = 1) {
            const searchRecord = this.getTabSearchRecord('disabled', page)
            await this.loadRecords(page, this.apiEndpoint, 'records', 'total', searchRecord)
            this.totalDisabled = this.total
        },
        async getTabTotal (tab) {
            try {
                const searchRecord = this.getTabSearchRecord(tab, 1)
                const data = await GenericService.getAll(this.apiEndpoint, { ...searchRecord, pageSize: 1 })
                return data.total || 0
            } catch (error) {
                return 0
            }
        },
        async refreshTabTotals () {
            this.totalPending = this.notSentRecords.length
            this.totalSent = this.sentRecords.length
            this.totalRejected = this.rejectedRecords.length
            this.totalDisabled = this.disabledRecords.length
        },
        async clearFilters () {
            this.searchRecord = {
                page: 1,
                pageSize: 35,
                order: 'DESC',
                status: []
            }
            this.range = null
            this.selectedPendingIds = []
            this.saveFilters()
            await this.loadRecordsByTab(1)
        },
        async sendFolios () {
            if (!Utils.userHasPerm('can_send_reune_complaint')) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            if (!this.selectedPendingIds.length) {
                this.$swal('Atención', 'Debe seleccionar al menos un folio para enviar', 'warning')
                return
            }
            const loader = this.$loading.show()
            try {
                const response = await GenericService.create('/reune/send', {
                    ids: this.selectedPendingIds
                })
                const s = response.summary
                const typeLabels = { consultas: 'Consultas', reclamaciones: 'Reclamaciones', aclaraciones: 'Aclaraciones' }
                let html = `<p><b>Total procesados:</b> ${s.total} &nbsp;|&nbsp; <b style="color:green">Enviados:</b> ${s.successful} &nbsp;|&nbsp; <b style="color:red">Rechazados:</b> ${s.rejected}</p>`
                for (const type of ['consultas', 'reclamaciones', 'aclaraciones']) {
                    const t = s.byType[type]
                    if (!t.successful.length && !t.rejected.length) continue
                    html += `<div style="text-align:left;margin-top:8px"><b>${typeLabels[type]}:</b>`
                    if (t.successful.length) html += ` <span style="color:green">✓ ${t.successful.length} enviados</span>`
                    if (t.rejected.length) {
                        html += ` <span style="color:red">✗ ${t.rejected.length} rechazados</span>`
                        for (const r of t.rejected) {
                            const errCount = Array.isArray(r.errors) ? r.errors.length : 1
                            html += `<div style="font-size:12px;margin-left:10px">Folio ${r.folio || r.id}: ${errCount} error(es)</div>`
                        }
                    }
                    html += '</div>'
                }
                this.$swal({ title: 'Proceso finalizado', html, icon: s.rejected > 0 ? 'warning' : 'success' })
                this.selectedPendingIds = []
            } catch (error) {
                const message = error?.data?.message || error?.message || 'Error al enviar folios'
                this.$swal('Error', message, 'error')
            } finally {
                await this.loadRecordsByTab(1)
                loader.hide()
            }
        },
        saveFilters () {
            const data = Object.assign({ range: this.range }, this.searchRecord)
            this.$store.dispatch('setFilters', { recordName: this.recordName, data })
        },
        formatDates () {
            if (!this.range) {
                delete this.searchRecord.fechaInicio
                delete this.searchRecord.fechaFin
            } else {
                if (this.range.start !== null) {
                    this.Vue.set(this.searchRecord, 'fechaInicio', this.moment.utc(this.range.start).format('YYYY-MM-DD'))
                }
                if (this.range.end !== null) {
                    this.Vue.set(this.searchRecord, 'fechaFin', this.moment.utc(this.range.end).format('YYYY-MM-DD'))
                }
            }
        },
        async loadStatus () {
            try {
                this.status = await ComplaintService.getReuneStatus()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los estatus de los registros REUNE')
            }
        },
        async loadOperations () {
            try {
                this.operations = await ComplaintService.getReuneOperations()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar las operaciones de los registros REUNE')
            }
        },
        async loadProducts () {
            try {
                this.products = await ComplaintService.getReuneProducts()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los productos de los registros REUNE')
            }
        },
        async loadSubproducts () {
            try {
                this.subproducts = await ComplaintService.getReuneSubproducts()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar los subproductos de los registros REUNE')
            }
        },
        async loadReasons () {
            try {
                this.reasons = await ComplaintService.getReuneReasons()
            } catch (error) {
                throw new Error('Ocurrió un error al cargar las causas de los registros REUNE')
            }
        },
        setReuneRecordStr (obj) {
            return Utils.displayOptionFromList(this.reuneRecordOptions, obj.complaintType)
        },
        setOperationStr (obj) {
            return Utils.displayOptionFromList(this.operationOptions, obj.operationId)
        },
        setProductStr (obj) {
            return Utils.displayOptionFromList(this.productOptions, obj.productId)
        },
        setSubproductStr (obj) {
            return Utils.displayOptionFromList(this.subproductOptions, obj.subproductId)
        },
        setReasonStr (obj) {
            return Utils.displayOptionFromList(this.reasonOptions, obj.reasonId)
        },
        setStatusStr (obj) {
            return Utils.displayOptionFromList(this.statusOptions, obj.statusId)
        },
        setSelectedRejectedIds (ids) {
            this.selectedRejectedIds = ids || []
        },

        async resetFolios () {
            if (!Utils.userHasPerm('can_reset_reune_complaint')) {
                this.$swal('Error', 'No tienes permiso para realizar la acción', 'error')
                return
            }
            if (!this.selectedRejectedIds.length) {
                this.$swal('Atención', 'Debe seleccionar al menos un folio para regresar a pendientes', 'warning')
                return
            }

            const loader = this.$loading.show()
            try {
                await GenericService.create('/reune/reset', { ids: this.selectedRejectedIds })
                this.$swal('Éxito', 'Los folios seleccionados han sido regresados a pendientes correctamente', 'success')
                this.selectedRejectedIds = []
            } catch (error) {
                const message = error.data.message || 'Error al regresar los folios a pendientes'
                this.$swal('Error', message, 'error')
            } finally {
                await this.loadRecordsByTab(1)
                loader.hide()
            }
        }
    }
}
</script>
